<template class="full-heigth">
  <!-- $t is vue-i18n global function to translate lang -->
  <div class="app-container" style="position: relative; height: 100%; padding: 15px">
    <el-dialog
      append-to-body
      v-loading="dialogSubLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogSubVisible"
      width="90%"
    >
      <el-card class="box-card">
        <el-row>
          <el-col :span="9" style="text-align: center">
            <el-image
              v-if="subImgInfo.file"
              :src="subImgInfo.file.url"
              style="height: 500px"
              fit="contain"
            >
            </el-image>
          </el-col>
          <el-col :span="15">
            <el-form label-width="80px" v-if="subImgInfo.info">
              <el-form-item label="檔案名稱">
                {{ subImgInfo.info.fileInfo.fileRealName }}
                <!-- <el-tag></el-tag> -->
              </el-form-item>

              <el-form-item label="上傳者">
                {{ subImgInfo.info.userInfo.name }}
                <!-- <el-tag>{{ subImgInfo.info.userInfo.name }}</el-tag> -->
              </el-form-item>

              <el-form-item label="上傳時間">
                {{ subImgInfo.info.fileInfo.buildDate }}
                <!-- <el-tag>{{ subImgInfo.info.fileInfo.buildDate }}</el-tag> -->
              </el-form-item>
              <!-- <el-form-item>
                <el-button
                  type="success"
                  @click="
                    downloadFile(subImgInfo.file.id, subImgInfo.file.fileName)
                  "
                  size="mini"
                  >下載圖片</el-button
                >
              </el-form-item> -->
            </el-form>
          </el-col>
        </el-row>
      </el-card>

      <span slot="footer" class="dialog-footer action-buttons">
        <!-- <a v-if="subImgInfo.file" :href="subImgInfo.file.url">DL</a>
        <a v-if="subImgInfo.file" :href="subImgInfo.file.url"  :download="subImgInfo.file.fileName">Download</a>
 -->
        <el-button
          type="success"
          @click="downloadFile(subImgInfo.file.id, subImgInfo.file.fileName)"
          >下 載</el-button
        >
        <el-popconfirm
          title="確定要刪除這張照片嗎？"
          cancel-button-text="取消"
          confirm-button-text="確定"
          @confirm="handleDeleteImage(subImgInfo.file.id)"
        >
          <el-button slot="reference" type="danger">刪 除</el-button>
        </el-popconfirm>
        <el-button @click="dialogSubVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <el-dialog
      @open="reSetAlubmSelected"
      v-loading="dialogLoading"
      :top="dialogTopMargin"
      :title="funcName + '維護'"
      :visible.sync="dialogVisible"
      width="90%"
    >
      <div style="color: red; font-size: 12px; margin-bottom: 10px">
        提示：第一次下載需要比較長時間處理，請耐心等候。
      </div>
      <el-card class="box-card">
        <!-- <el-row>
          <el-switch
            style="margin: 5px"
            v-model="showChk"
            active-text="選擇圖片"
            :active-value="true"
            :inactive-value="false"
            inactive-text="單張預覽"
          >
          </el-switch>
        </el-row> -->

        <el-row style="margin-bottom: 10px">
          <el-form :inline="true" class="imageUpload">
            <el-form-item label="圖片下載/刪除">
              <el-checkbox-group v-model="downloadType" @change="handleSelectList">
                <el-checkbox label="agency">旅行社全部</el-checkbox>
                <el-checkbox label="leader">領隊全部</el-checkbox>
                <el-checkbox label="travelers">旅客全部</el-checkbox>
                <el-checkbox label="all">全選</el-checkbox>
              </el-checkbox-group>
            </el-form-item>

            <el-form-item>
              <el-tag style="margin-left: 10px" v-if="imageIDs.length > 0"
                >{{ `共選擇 ${imageIDs.length} 張照片` }}
              </el-tag>

              <el-button
                type="warning"
                size="mini"
                style="margin-top: 10px"
                @click="cancelSelect"
                v-show="imageIDs.length > 0"
                >取消多選</el-button
              >
            </el-form-item>
          </el-form>
        </el-row>

        <!-- <el-button size="mini" type="warning">下載全部</el-button> -->
        <!-- <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        > -->

        <el-tabs v-model="activeAlbumName" type="border-card">
          <el-tab-pane label="旅行社" name="agency">
            <div
              class="album-group__container"
              v-show="!downloadType || downloadType.length == 0 || downloadType == 'cancelCheck'"
            >
              <div v-show="spinLoading">
                <el-icon name="loading" style="font-size: 24px; color: #aaa9a9"></el-icon>
              </div>
              <div
                v-show="!spinLoading"
                v-for="groupTag in albumGroupTag"
                :key="groupTag.id"
                class="album-group"
                :class="{ 'album-group--active': selectedAlbumGroupTag.id == groupTag.groupTagId }"
                @click="handleSelectGroupTag(groupTag)"
              >
                <div
                  style="
                    width: 100%;
                    display: flex;
                    gap: 8px;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="display: flex; align-items: center; gap: 0 8px">
                    <div class="icon-container">
                      <el-icon
                        name="folder"
                        class="icon-folder"
                        :class="{
                          'icon-folder--active': selectedAlbumGroupTag.id == groupTag.groupTagId,
                        }"
                      ></el-icon>
                    </div>
                    <span
                      class="album-group__name"
                      :class="{
                        'album-group__name--active':
                          selectedAlbumGroupTag.id == groupTag.groupTagId,
                      }"
                    >
                      {{ groupTag.groupTagName }}
                    </span>
                  </div>
                  <el-popconfirm
                    :title="
                      !groupTag.groupTagId
                        ? '是否要刪除未分類相簿內所有照片？'
                        : '確定要刪除此相簿嗎?'
                    "
                    @confirm="handleDeleteConfirm(groupTag.groupTagId)"
                    confirm-button-text="確認"
                    cancel-button-text="取消"
                  >
                    <div class="icon-container__delete" slot="reference">
                      <el-icon name="delete" class="icon-delete"></el-icon>
                    </div>
                  </el-popconfirm>
                </div>
              </div>
            </div>
            <div
              v-if="travelAlbums.agencyAlbum && travelAlbums.agencyAlbum.length > 0"
              style="max-height: 450px; overflow: auto"
            >
              <el-checkbox-group v-if="showChk" v-model="imageIDs">
                <template v-for="item in filterAgencyAlbum">
                  <template v-for="(f, index) in item.files">
                    <el-checkbox :label="f.id" :key="index">
                      <el-image class="imgs" style="width: 100px; height: 100px" :src="f.url">
                      </el-image>
                    </el-checkbox>
                  </template>
                </template>
              </el-checkbox-group>
              <template v-else>
                <template v-for="item in filterAgencyAlbum">
                  <template v-for="(f, index) in item.files">
                    <el-image
                      :key="index"
                      class="imgs"
                      style="width: 100px; height: 100px; cursor: pointer"
                      :src="f.url"
                      @click="checkImage(f.id)"
                    >
                    </el-image>
                  </template>
                </template>
              </template>
            </div>
            <div v-else>
              <span>查無資料</span>
            </div>
          </el-tab-pane>
          <el-tab-pane label="領隊" name="leader">
            <!-- <span slot="label">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkLeaderAll"
                @change="handleCheckAllChange($event, 'single')"
              ></el-checkbox>
              領隊上傳</span
            > -->
            <div
              class="album-group__container"
              v-show="!downloadType || downloadType.length == 0 || downloadType == 'cancelCheck'"
            >
              <div v-show="spinLoading">
                <el-icon name="loading" style="font-size: 24px; color: #aaa9a9"></el-icon>
              </div>
              <div
                v-show="!spinLoading"
                v-for="groupTag in albumGroupTag"
                :key="groupTag.id"
                class="album-group"
                :class="{ 'album-group--active': selectedAlbumGroupTag.id == groupTag.groupTagId }"
                @click="handleSelectGroupTag(groupTag)"
              >
                <div
                  style="
                    width: 100%;
                    display: flex;
                    gap: 8px;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="display: flex; align-items: center; gap: 0 8px">
                    <div class="icon-container">
                      <el-icon
                        name="folder"
                        class="icon-folder"
                        :class="{
                          'icon-folder--active': selectedAlbumGroupTag.id == groupTag.groupTagId,
                        }"
                      ></el-icon>
                    </div>
                    <span
                      class="album-group__name"
                      :class="{
                        'album-group__name--active':
                          selectedAlbumGroupTag.id == groupTag.groupTagId,
                      }"
                    >
                      {{ groupTag.groupTagName }}
                    </span>
                  </div>
                  <el-popconfirm
                    :title="
                      !groupTag.groupTagId
                        ? '是否要刪除未分類相簿內所有照片？'
                        : '確定要刪除此相簿嗎?'
                    "
                    @confirm="handleDeleteConfirm(groupTag.groupTagId)"
                    confirm-button-text="確認"
                    cancel-button-text="取消"
                  >
                    <div class="icon-container__delete" slot="reference">
                      <el-icon name="delete" class="icon-delete"></el-icon>
                    </div>
                  </el-popconfirm>
                </div>
              </div>
            </div>
            <div
              v-if="travelAlbums.leaderAlbum && travelAlbums.leaderAlbum.length > 0"
              style="max-height: 450px; overflow: auto"
            >
              <el-checkbox-group v-if="showChk" v-model="imageIDs">
                <template v-for="item in filterLeaderAlbum">
                  <template v-for="(f, index) in item.files">
                    <el-checkbox :label="f.id" :key="index">
                      <el-image class="imgs" style="width: 100px; height: 100px" :src="f.url">
                      </el-image>
                    </el-checkbox>
                  </template>
                </template>
              </el-checkbox-group>
              <template v-else>
                <template v-for="item in filterLeaderAlbum">
                  <template v-for="(f, index) in item.files">
                    <el-image
                      :key="index"
                      class="imgs"
                      style="width: 100px; height: 100px; cursor: pointer"
                      :src="f.url"
                      @click="checkImage(f.id)"
                    >
                    </el-image>
                  </template>
                </template>
              </template>
            </div>
            <div v-else>
              <span>查無資料</span>
              <!-- <el-alert title="尚未上傳照片" type="error" :closable="false">
              </el-alert> -->
            </div>
          </el-tab-pane>

          <el-tab-pane label="旅客" name="travelers">
            <!-- <span slot="label">
              <el-checkbox
                :indeterminate="isIndeterminate"
                v-model="checkTravelersAll"
                @change="handleCheckAllChange($event, 'single')"
              ></el-checkbox>
              旅客上傳</span
            > -->
            <div
              class="album-group__container"
              v-show="!downloadType || downloadType.length == 0 || downloadType == 'cancelCheck'"
            >
              <div v-show="spinLoading">
                <el-icon name="loading" style="font-size: 24px; color: #aaa9a9"></el-icon>
              </div>
              <div
                v-show="!spinLoading"
                v-for="groupTag in albumGroupTag"
                :key="groupTag.id"
                class="album-group"
                :class="{ 'album-group--active': selectedAlbumGroupTag.id == groupTag.groupTagId }"
                @click="handleSelectGroupTag(groupTag)"
              >
                <div
                  style="
                    width: 100%;
                    display: flex;
                    gap: 8px;
                    justify-content: space-between;
                    align-items: center;
                  "
                >
                  <div style="display: flex; align-items: center; gap: 0 8px">
                    <div class="icon-container">
                      <el-icon
                        name="folder"
                        class="icon-folder"
                        :class="{
                          'icon-folder--active': selectedAlbumGroupTag.id == groupTag.groupTagId,
                        }"
                      ></el-icon>
                    </div>
                    <span
                      class="album-group__name"
                      :class="{
                        'album-group__name--active':
                          selectedAlbumGroupTag.id == groupTag.groupTagId,
                      }"
                    >
                      {{ groupTag.groupTagName }}
                    </span>
                  </div>
                  <el-popconfirm
                    :title="
                      !groupTag.groupTagId
                        ? '是否要刪除未分類相簿內所有照片？'
                        : '確定要刪除此相簿嗎?'
                    "
                    @confirm="handleDeleteConfirm(groupTag.groupTagId)"
                    confirm-button-text="確認"
                    cancel-button-text="取消"
                  >
                    <div class="icon-container__delete" slot="reference">
                      <el-icon name="delete" class="icon-delete"></el-icon>
                    </div>
                  </el-popconfirm>
                </div>
              </div>
            </div>
            <div
              v-if="travelAlbums.travelerAlbum && travelAlbums.travelerAlbum.length > 0"
              style="max-height: 450px; overflow: auto"
            >
              <el-checkbox-group v-if="showChk" v-model="imageIDs">
                <template v-for="item in filterTravelerAlbum">
                  <template v-for="(f, index) in item.files">
                    <el-checkbox :label="f.id" :key="index">
                      <el-image class="imgs" style="width: 100px; height: 100px" :src="f.url">
                      </el-image>
                    </el-checkbox>
                  </template>
                </template>
              </el-checkbox-group>
              <template v-else>
                <template v-for="item in filterTravelerAlbum">
                  <template v-for="(f, index) in item.files">
                    <el-image
                      :key="index"
                      class="imgs"
                      style="width: 100px; height: 100px; cursor: pointer"
                      :src="f.url"
                      @click="checkImage(f.id)"
                    >
                    </el-image>
                  </template>
                </template>
              </template>
            </div>
            <div v-else>
              <!-- <el-alert title="尚未上傳照片" type="error" :closable="false">
              </el-alert> -->
              <span>查無資料</span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-card>

      <span slot="footer" class="dialog-footer action-buttons">
        <el-button @click="downloadImages" type="success" v-if="imageIDs.length > 0"
          >下 載</el-button
        >
        <!-- <el-button @click="downloadPatchImages" type="success" v-if="selectedAlbumGroupTagBool"
          >{{ selectedAlbumGroupTag.name }} 相簿下載</el-button
        > -->
        <el-popconfirm
          title="確定要刪除選取的照片嗎？"
          v-if="activeAlbumName == 'agency' && imageIDs.length > 0"
          cancel-button-text="取消"
          confirm-button-text="確定"
          @confirm="handleDeleteImages"
        >
          <el-button slot="reference" type="danger">刪 除</el-button>
        </el-popconfirm>

        <el-button @click="dialogVisible = false">關 閉</el-button>
      </span>
    </el-dialog>

    <!-- <div style="padding: 20px; padding-bottom: 0">
      <el-form :inline="true">
        <el-form-item label="查詢">
          <el-input
            size="mini"
            v-model="listQuery.qry"
            placeholder="輸入團號或團名"
          />
        </el-form-item>

        <el-form-item>
          <el-button size="mini" type="primary" @click="getAgencyTravels"
            >查詢</el-button
          >
        </el-form-item>
      </el-form>
    </div> -->

    <el-form :inline="true" class="filter-form" @submit.native.prevent>
      <el-form-item label="查詢">
        <el-input
          v-model="listQuery.qry"
          placeholder="輸入團號或團名"
          @keyup.enter.native="getAgencyTravels"
        />
      </el-form-item>

      <el-button
        type="primary"
        @click="getAgencyTravels"
        icon="el-icon-search"
        circle
        style="margin-top: 8px; margin-left: 5px"
        :disabled="listLoading"
      ></el-button>
      <el-button
        style="cursor: pointer"
        type="success"
        :loading="listLoading"
        circle
        icon="el-icon-refresh-left"
        @click="refresh()"
      ></el-button>
    </el-form>

    <div style="position: relative; height: 80%" v-loading="listLoading">
      <el-table size="mini" :data="list" border style="width: 100%" height="100%">
        <el-table-column align="center" label="項次" width="60">
          <template slot-scope="scope">
            <span>{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>

        <el-table-column prop="tourGroupNo" label="團號" width="200" align="center">
        </el-table-column>
        <el-table-column align="center" label="團名" width="450">
          <template slot-scope="{ row }">
            <span>{{ row.travelName }}</span>
            <div>
              <el-tag style="font-size: 14px">
                出發
                <span style="color: red">{{ `${row.beginDate} ${row.beginTime}` }}</span>
                - 回程
                <span style="color: red">{{ `${row.endDate} ${row.endTime}` }}</span>
              </el-tag>
            </div>
          </template>
        </el-table-column>
        <!-- <el-table-column align="center" label="團名">
          <template slot-scope="{ row }">
            <span>{{ row.travelName }}</span>
            <div>
              <el-tag>
                出發{{ `${row.beginDate} ${row.beginTime}` }} - 回程{{
                  `${row.endDate} ${row.endTime}`
                }}
              </el-tag>
            </div>
          </template>
        </el-table-column> -->

        <el-table-column align="center" label="查看相簿" width="100">
          <template slot-scope="scope">
            <el-button size="mini" type="info" @click="getAlbum(scope.row.id)">查看</el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="上傳圖片" width="100">
          <template slot-scope="scope">
            <!-- TODO: 新增上傳功能 -->
            <div @click="getPhotoToPublicAlbumGroupTag(scope.row.id, true)">
              <MultipleImage
                :title="`上傳圖片（團號：${scope.row.tourGroupNo}）`"
                :travelId="scope.row.id"
                :groupNo="scope.row.tourGroupNo"
                :albumGroupTag="albumGroupTag"
                @successCBK="handleImageUploadSuccess"
                @getGroupTagList="getPhotoToPublicAlbumGroupTag(scope.row.id, true)"
              />
            </div>
          </template>
        </el-table-column>
      </el-table>

      <pagination
        v-show="total > 0"
        layout="prev, pager, next"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.limit"
        @pagination="getAgencyTravels"
      />
    </div>
  </div>
</template>

<script>
import { downloadAs } from '@/utils/funcs'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import MultipleImage from '@/components/Upload/MultipleImage'

import request from '@/utils/request'

import { getAgencyTravels } from '@/api/agency'
import {
  getPublicAlbum,
  getPublicAlbumAnPhoto,
  getPhotoToPublicAlbumGroupTag,
  deletePublicAlbumAnPhoto,
  deletePhotoToPublicAlbumGroupTag,
} from '@/api/travel'
import { cloneDeep, isEmpty } from 'lodash-es'

export default {
  name: 'PublicAlbum',
  components: {
    Pagination,
    MultipleImage,
  },
  watch: {
    // showChk: {
    //   handler: function (newVal, oldVal) {
    //     let vm = this;
    //     if (!newVal) {
    //       // vm.checkAll = newVal;
    //       // vm.checkLeaderAll = newVal;
    //       // vm.checkTravelersAll = newVal;
    //       vm.imageIDs = [];
    //     }
    //   },
    //   deep: true,
    //   immediate: true,
    // },
    activeAlbumName: {
      handler: async function (newVal, oldVal) {
        let vm = this
        if (newVal !== oldVal && !!newVal) {
          console.log('activeAlbumName', newVal)
          vm.getPhotoToPublicAlbumGroupTag(vm.travelID)
        }
      },
      immediate: true,
      deep: true,
    },
  },
  data() {
    return {
      //isIndeterminate: true,
      // checkAll: false,
      // checkLeaderAll: false,
      // checkTravelersAll: false,
      imageIDs: [],
      showChk: false,
      activeAlbumName: 'agency',
      // activeAlbumName: "leader",
      travelID: null,
      funcName: '相簿',
      dialogUploadVisible: false,
      dialogVisible: false,
      dialogLoading: false,
      dialogSubVisible: false,
      dialogSubLoading: false,
      listLoading: false,
      spinLoading: false,
      dialogTopMargin: '2%',
      formLabelWidth: '120px',
      listQuery: {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-buildDate',
      },
      total: 0,
      list: [],
      travelAlbums: {},
      subImgInfo: {},
      downloadType: [],
      albumGroupTag: [],
      selectedAlbumGroupTag: {
        id: null,
        name: null,
      },
      selectedAlbumGroupTagBool: false, // 是否有選擇相簿分組
    }
  },
  async created() {
    this.imageIDs = []
    await this.getAgencyTravels()
  },
  computed: {
    filterAgencyAlbum() {
      if (!isEmpty(this.travelAlbums.agencyAlbum)) {
        const deepCloneArr = cloneDeep(this.travelAlbums.agencyAlbum)
        const mapNewAlbum = deepCloneArr.map(albumItem => {
          const filterArr = albumItem.files.filter(
            item =>
              // 這裡型態務必一致
              String(item.mapGroupTagId) == String(this.selectedAlbumGroupTag.id) ||
              item.mapGroupTagName == this.selectedAlbumGroupTag.name
          )
          albumItem.files = filterArr
          this.selectedAlbumGroupTagBool = true
          return albumItem
        })
        return mapNewAlbum
      } else {
        return []
      }
    },
    filterLeaderAlbum() {
      if (!isEmpty(this.travelAlbums.leaderAlbum)) {
        const deepCloneArr = cloneDeep(this.travelAlbums.leaderAlbum)
        const mapNewAlbum = deepCloneArr.map(albumItem => {
          const filterArr = albumItem.files.filter(
            item =>
              // 這裡型態務必一致
              String(item.mapGroupTagId) == String(this.selectedAlbumGroupTag.id) ||
              item.mapGroupTagName == this.selectedAlbumGroupTag.name
          )
          albumItem.files = filterArr
          this.selectedAlbumGroupTagBool = true
          return albumItem
        })
        return mapNewAlbum
      } else {
        return []
      }
    },
    filterTravelerAlbum() {
      if (!isEmpty(this.travelAlbums.travelerAlbum)) {
        const deepCloneArr = cloneDeep(this.travelAlbums.travelerAlbum)
        const mapNewAlbum = deepCloneArr.map(albumItem => {
          const filterArr = albumItem.files.filter(
            item =>
              // 這裡型態務必一致
              String(item.mapGroupTagId) == String(this.selectedAlbumGroupTag.id) ||
              item.mapGroupTagName == this.selectedAlbumGroupTag.name
          )
          albumItem.files = filterArr
          this.selectedAlbumGroupTagBool = true
          return albumItem
        })
        return mapNewAlbum
      } else {
        return []
      }
    },
    // 各分組動態產生 ID 陣列，純計算、無副作用
    filterAgencyAlbumImageIDs() {
      const ids = []
      this.filterAgencyAlbum.forEach(albumItem => {
        albumItem.files.forEach(f => ids.push(f.id))
      })
      return ids
    },
    filterLeaderAlbumImageIDs() {
      const ids = []
      this.filterLeaderAlbum.forEach(albumItem => {
        albumItem.files.forEach(f => ids.push(f.id))
      })
      return ids
    },
    filterTravelerAlbumImageIDs() {
      const ids = []
      this.filterTravelerAlbum.forEach(albumItem => {
        albumItem.files.forEach(f => ids.push(f.id))
      })
      return ids
    },

    // 統一出口，根據 activeAlbumName 回傳正確的 IDs
    selectedAlbumGroupTagImageIDs() {
      // 已改為 computed getter，移除 data 寫入
      if (this.activeAlbumName === 'agency') return this.filterAgencyAlbumImageIDs
      if (this.activeAlbumName === 'leader') return this.filterLeaderAlbumImageIDs
      if (this.activeAlbumName === 'travelers') return this.filterTravelerAlbumImageIDs
      return []
    },
  },
  methods: {
    handleImageUploadSuccess(arr) {
      console.log('handleImageUploadSuccess')
      console.log(arr)
    },
    reSetAlubmSelected() {
      // this.checkAll = false;
      // this.checkLeaderAll = false;
      // this.checkTravelersAll = false;
      this.imageIDs = []
    },
    handleSelectList(val) {
      if (this.downloadType.length > 1) {
        this.downloadType.splice(0, 1)
      }
      this.selectedAlbumGroupTagBool = false // 每次選擇全選時，先清空選擇的相簿分組
      this.handleCheckAllChange()
    },
    // async downloadImages() {
    //   if (!this.imageIDs || this.imageIDs.length == 0) {
    //     alert(`未選擇照片。`);
    //     return;
    //   }
    //   this.dialogLoading = true;
    //   const url = `/TravelSettings/downloadImages`;
    //   try {
    //     let data = this.imageIDs;
    //     let response = await request({
    //       url: url,
    //       method: "post",
    //       data: { ids: data },
    //       // headers: {
    //       //   "Content-Type": "application/octet-stream",
    //       // },
    //       responseType: "blob",
    //     });
    //     const a = document.createElement("a");
    //     const u = window.URL.createObjectURL(response);
    //     a.href = u;
    //     a.download = `相簿.zip`;
    //     a.click();
    //     this.dialogLoading = false;

    //     this.$notify({
    //       title: "成功",
    //       message: "相簿批次下載處理完成",
    //       type: "success",
    //     });
    //   } catch (error) {
    //     console.log("error", error);
    //     this.dialogLoading = false;
    //   }
    // },

    // 下載照片新方法，該由接收json格式，並解析出下載zip網址
    async downloadImages() {
      if (!this.imageIDs || this.imageIDs.length == 0) {
        alert(`未選擇照片。`)
        return
      }
      this.dialogLoading = true
      await this.$store.dispatch(
        'app/showDownloadLoadingText',
        '照片正在打包下載中，請不要離開此畫面，感謝您的耐心等候。'
      )
      await this.$store.dispatch('app/showDownloadLoading', this.dialogLoading)

      const url = `/TravelSettings/downloadImages`
      try {
        let data = this.imageIDs
        let response = await request({
          url: url,
          method: 'post',
          data: { ids: data },
          headers: {
            'Content-Type': 'application/json',
          },
          // responseType: "blob",
        })

        // 為了讓檔名可以指定，取得url後，再進行下載
        const downloadUrl = response.data.downLoadUrl

        // 下載後創建 Blob
        const fileResponse = await fetch(downloadUrl)
        const blob = await fileResponse.blob()
        const blobUrl = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = blobUrl
        // 下載檔名
        a.download = `相簿.zip`

        // const a = document.createElement("a");
        // // const u = window.URL.createObjectURL(response);
        // a.href = response.data.downLoadUrl;
        // a.download = `相簿.zip`;

        a.click()
        this.dialogLoading = false
        await this.$store.dispatch('app/showDownloadLoading', this.dialogLoading)
        await this.$store.dispatch('app/showDownloadLoadingText', '')

        this.$notify({
          title: '成功',
          message: '相簿批次下載處理完成',
          type: 'success',
        })
      } catch (error) {
        console.log('error', error)
        this.dialogLoading = false
        await this.$store.dispatch('app/showDownloadLoading', this.dialogLoading)
        await this.$store.dispatch('app/showDownloadLoadingText', '')
      }
    },

    async downloadPatchImages() {
      if (!this.selectedAlbumGroupTagImageIDs || this.selectedAlbumGroupTagImageIDs.length == 0) {
        alert(`相簿內沒有照片。`)
        return
      }
      this.dialogLoading = true
      await this.$store.dispatch(
        'app/showDownloadLoadingText',
        '照片正在打包下載中，請不要離開此畫面，感謝您的耐心等候。'
      )
      await this.$store.dispatch('app/showDownloadLoading', this.dialogLoading)

      const url = `/TravelSettings/downloadImages`
      try {
        let data = this.selectedAlbumGroupTagImageIDs
        let response = await request({
          url: url,
          method: 'post',
          data: { ids: data },
          headers: {
            'Content-Type': 'application/json',
          },
          // responseType: "blob",
        })

        // 為了讓檔名可以指定，取得url後，再進行下載
        const downloadUrl = response.data.downLoadUrl

        // 下載後創建 Blob
        const fileResponse = await fetch(downloadUrl)
        const blob = await fileResponse.blob()
        const blobUrl = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = blobUrl
        // 下載檔名
        a.download = this.selectedAlbumGroupTag.name + `.zip`

        // const a = document.createElement("a");
        // // const u = window.URL.createObjectURL(response);
        // a.href = response.data.downLoadUrl;
        // a.download = `相簿.zip`;

        a.click()
        this.dialogLoading = false
        await this.$store.dispatch('app/showDownloadLoading', this.dialogLoading)
        await this.$store.dispatch('app/showDownloadLoadingText', '')

        this.$notify({
          title: '成功',
          message: '相簿批次下載處理完成',
          type: 'success',
        })
      } catch (error) {
        console.log('error', error)
        this.dialogLoading = false
        await this.$store.dispatch('app/showDownloadLoading', this.dialogLoading)
        await this.$store.dispatch('app/showDownloadLoadingText', '')
      }
    },

    // 刪除旅行社照片(批次)
    async handleDeleteImages() {
      if (!this.imageIDs || this.imageIDs.length == 0) {
        alert(`未選擇照片。`)
        return
      }
      this.dialogLoading = true
      const params = {
        travelID: this.travelID,
        ids: this.imageIDs,
      }
      await deletePublicAlbumAnPhoto(params)
        .then(async res => {
          this.$notify({
            title: '成功',
            message: '相簿批次刪除處理完成',
            type: 'success',
          })
          this.imageIDs = []
          this.downloadType = []
          this.showChk = false
          await this.getAlbum(this.travelID)
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => (this.dialogLoading = false))
    },
    // 刪除旅行社照片(單張)
    async handleDeleteImage(id) {
      if (!id) return
      this.dialogLoading = true
      const params = {
        travelID: this.travelID,
        ids: [id],
      }
      await deletePublicAlbumAnPhoto(params)
        .then(async res => {
          this.$notify({
            title: '成功',
            message: '相簿刪除處理完成',
            type: 'success',
          })
          await this.getAlbum(this.travelID)
          this.dialogSubVisible = false
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => (this.dialogLoading = false))
    },

    handleCheckAllChange() {
      let vm = this
      this.showChk = this.downloadType.length > 0
      vm.imageIDs = []

      if (this.showChk) {
        var type = this.downloadType[0]
        if (type == 'all') {
          //vm.checkAll = val;
          //vm.checkLeaderAll = val;
          //vm.checkTravelersAll = val;
          let albums = []
          albums.push(vm.travelAlbums.agencyAlbum)
          albums.push(vm.travelAlbums.leaderAlbum)
          albums.push(vm.travelAlbums.travelerAlbum)
          albums.forEach(f => {
            if (f && f.length > 0) {
              let album = f[0]
              let files = album.files
              if (files && files.length > 0) {
                files.forEach(f => {
                  if (vm.imageIDs.indexOf(f.id) == -1) {
                    vm.imageIDs.push(f.id)
                  }
                })
              }
            }
            // if (val) {

            // } else {
            //   vm.imageIDs = [];
            // }
          })
        } else if (type == 'cancelCheck') {
          this.showChk = false
        } else {
          this.activeAlbumName = type
          let albumFilter =
            vm.activeAlbumName == 'agency'
              ? vm.travelAlbums.agencyAlbum
              : vm.activeAlbumName == 'leader'
                ? vm.travelAlbums.leaderAlbum
                : vm.travelAlbums.travelerAlbum

          // if (vm.activeAlbumName == "leader") {
          //   vm.checkLeaderAll = val;
          // } else {
          //   vm.checkTravelersAll = val;
          // }
          if (albumFilter && albumFilter.length > 0) {
            let album = albumFilter[0]
            let files = album.files
            if (files && files.length > 0) {
              files.forEach(f => {
                vm.imageIDs.push(f.id)
              })
            }
          }
          // if (val) {
          //   if (albumFilter && albumFilter.length > 0) {
          //     let album = albumFilter[0];
          //     let files = album.files;
          //     if (files && files.length > 0) {
          //       files.forEach((f) => {
          //         vm.imageIDs.push(f.id);
          //       });
          //     }
          //   }
          // } else {
          //   let album = albumFilter[0];
          //   let files = album.files;
          //   if (files && files.length > 0) {
          //     files.forEach((f) => {
          //       if (vm.imageIDs.indexOf(f.id) != -1) {
          //         vm.imageIDs.splice(vm.imageIDs.indexOf(f.id), 1);
          //       }
          //     });
          //   }
          // }
        }
      }
      //this.isIndeterminate = false;
    },
    // handleCheckAllChange(val, type) {
    //   let vm = this;
    //   if (!vm.showChk && val) {
    //     vm.showChk = val;
    //   }

    //   if (type == "all") {
    //     vm.checkAll = val;
    //     vm.checkLeaderAll = val;
    //     vm.checkTravelersAll = val;
    //     let albums = [];
    //     albums.push(vm.travelAlbums.leaderAlbum);
    //     albums.push(vm.travelAlbums.travelerAlbum);

    //     albums.forEach((f) => {
    //       if (val) {
    //         if (f && f.length > 0) {
    //           let album = f[0];
    //           let files = album.files;
    //           if (files && files.length > 0) {
    //             files.forEach((f) => {
    //               if (vm.imageIDs.indexOf(f.id) == -1) {
    //                 vm.imageIDs.push(f.id);
    //               }
    //             });
    //           }
    //         }
    //       } else {
    //         vm.imageIDs = [];
    //       }
    //     });
    //   } else {
    //     let albumFilter =
    //       vm.activeAlbumName == "leader"
    //         ? vm.travelAlbums.leaderAlbum
    //         : vm.travelAlbums.travelerAlbum;

    //     if (vm.activeAlbumName == "leader") {
    //       vm.checkLeaderAll = val;
    //     } else {
    //       vm.checkTravelersAll = val;
    //     }

    //     if (val) {
    //       if (albumFilter && albumFilter.length > 0) {
    //         let album = albumFilter[0];
    //         let files = album.files;
    //         if (files && files.length > 0) {
    //           files.forEach((f) => {
    //             vm.imageIDs.push(f.id);
    //           });
    //         }
    //       }
    //     } else {
    //       let album = albumFilter[0];
    //       let files = album.files;
    //       if (files && files.length > 0) {
    //         files.forEach((f) => {
    //           if (vm.imageIDs.indexOf(f.id) != -1) {
    //             vm.imageIDs.splice(vm.imageIDs.indexOf(f.id), 1);
    //           }
    //         });
    //       }
    //     }
    //   }

    //   this.isIndeterminate = false;
    // },
    // handleCheckedImageChange(value) {
    //   // console.log(this.imageIDs);
    // },

    async refresh() {
      let vm = this
      this.listQuery = {
        qry: '',
        date: '',
        status: null,
        page: 1,
        limit: 20,
        sort: '-buildDate',
      }
      await vm.getAgencyTravels()
    },
    async getAgencyTravels() {
      this.listLoading = true
      let resp = await getAgencyTravels(this.listQuery)
      this.list = resp.data.data
      this.total = resp.data.total
      this.listLoading = false
    },
    // 上傳圖片
    uploadAlbum(travelID) {
      this.travelID = travelID
      this.dialogUploadVisible = true
    },
    async getAlbum(travelID) {
      this.travelID = travelID
      this.listLoading = true
      let resp = await getPublicAlbum({ travelID })
      this.travelAlbums = resp.data
      await this.getPhotoToPublicAlbumGroupTag(this.travelID)
      this.listLoading = false
      this.dialogVisible = true
    },
    async checkImage(id) {
      this.dialogSubVisible = true
      this.dialogSubLoading = true
      let resp = await getPublicAlbumAnPhoto({
        travelID: this.travelID,
        fileID: id,
      })
      this.subImgInfo = resp.data
      this.dialogSubLoading = false
    },
    async downloadFile(id, fileName) {
      this.dialogSubLoading = true
      await this.$store.dispatch('app/showDownloadLoading', this.dialogSubLoading)
      await downloadAs(id, fileName)
        .then(res => {
          this.$notify({
            title: '成功',
            message: '相簿下載處理完成',
            type: 'success',
          })
        })
        .catch(error => {
          console.log(error)
        })
        .finally(() => {
          this.dialogSubLoading = false
          this.$store.dispatch('app/showDownloadLoading', this.dialogSubLoading)
        })
    },

    // 取得共享相簿群組
    async getPhotoToPublicAlbumGroupTag(id, isUpdate = false) {
      if (!id) return
      this.spinLoading = true
      const data = await getPhotoToPublicAlbumGroupTag({ travelID: id })
      this.spinLoading = false
      const AllAlbumGroupTag = data.success
        ? data.data.reduce((acc, obj) => {
            let key = Object.keys(obj)[0]
            let value = obj[key]
            acc[key] = value
            return acc
          }, {})
        : {}
      this.albumGroupTag = isUpdate
        ? AllAlbumGroupTag.agencyGroupTag
        : AllAlbumGroupTag[`${this.activeAlbumName}GroupTag`]
      this.selectedAlbumGroupTag.id = this.albumGroupTag[0].groupTagId
      this.selectedAlbumGroupTag.name = this.albumGroupTag[0].groupTagName
    },

    // 刪除共享相簿群組
    async handleDeleteConfirm(groupTagId) {
      // 未分類相簿（刪除相簿內所有照片）
      if (!groupTagId) {
        const deepCloneArr = cloneDeep(this.filterAlbum)
        const fileArr = deepCloneArr.map(item => item.files).flat()
        const ids = fileArr.map(filterAlbumItem => filterAlbumItem.id)
        if (isEmpty(ids)) {
          this.$notify({
            title: '提示',
            message: '當前相簿沒有照片',
            type: 'warning',
          })
          return
        }
        const deleteParams = {
          travelID: this.travelID,
          ids: ids,
        }
        await deletePublicAlbumAnPhoto(deleteParams)
          .then(async res => {
            if (res.success) {
              await this.getAlbum(this.travelID)
            }
          })
          .catch(error => {
            console.log(error)
          })
        return
      }
      const params = {
        travelID: this.travelId,
        groupTagId: groupTagId,
      }
      const data = await deletePhotoToPublicAlbumGroupTag(params)
      if (data.success) {
        if (this.selectedAlbumGroupTag.id == groupTagId) {
          this.selectedAlbumGroupTag = {
            id: null,
            name: null,
          }
        }
        const filterData = this.albumGroupTag.filter(item => item.groupTagId != groupTagId)
        this.albumGroupTag = filterData
      }
    },
    // 選擇相簿
    handleSelectGroupTag(albumGroupTag) {
      this.showChk = false // 每次選擇相簿分組時，先清空選擇的相簿分組
      this.imageIDs = [] // 清空 imageIDs
      // 完整替換 selectedAlbumGroupTag 物件
      this.selectedAlbumGroupTag = {
        id: albumGroupTag.groupTagId,
        name: albumGroupTag.groupTagName,
      }

      this.downloadType = [] // 清空下載類型，避免重複選擇

      // 新增：自動選取該分組所有照片
      let albumList = []
      if (this.activeAlbumName === 'agency') {
        albumList = this.travelAlbums.agencyAlbum || []
      } else if (this.activeAlbumName === 'leader') {
        albumList = this.travelAlbums.leaderAlbum || []
      } else if (this.activeAlbumName === 'travelers') {
        albumList = this.travelAlbums.travelerAlbum || []
      }
      // 找出所有符合分組的照片 id
      const ids = []
      albumList.forEach(albumItem => {
        albumItem.files.forEach(item => {
          if (
            String(item.mapGroupTagId) == String(albumGroupTag.groupTagId) ||
            item.mapGroupTagName == albumGroupTag.groupTagName
          ) {
            ids.push(item.id)
          }
        })
      })
      this.imageIDs = ids
      this.showChk = true // 顯示 checkbox
    },

    cancelSelect() {
      this.downloadType = ['cancelCheck']
      this.handleSelectList(['cancelCheck'])
    },
  },
}
</script>

<style>
.el-dialog__body {
  padding: 15px !important;
}
</style>

<style scoped>
.el-tab-pane {
  height: auto !important;
  /* overflow-y: auto; */
}

.imageUpload .el-form-item {
  margin-bottom: 0px !important;
}

.full-heigth {
  position: relative;
  height: 100%;
}

.el-icon-circle-close {
  color: wheat !important;
}

.imgs {
  margin: 0 8px 10px 8px;
}

/deep/.el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #ffd643 !important;
  border: 1px solid #ffd643 !important;
}

/deep/.el-checkbox__inner:hover {
  border-color: #ffd643;
}

/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #4b4b4b;
}

/deep/.el-checkbox__input.is-focus .el-checkbox__inner {
  border-color: #ffd643 !important;
}

/deep/.el-checkbox__inner {
  width: 20px;
  height: 20px;
}

/deep/.el-checkbox__inner {
  width: 20px;
  height: 20px;
}

/deep/.el-checkbox__inner::after {
  height: 12px;
  left: 7px;
}

.action-buttons {
  display: flex;
  gap: 0 8px;
  justify-content: flex-end;
}

.album-group__container {
  display: flex;
  gap: 0 8px;
  padding-bottom: 24px;
  width: 95%;
  white-space: nowrap;
  overflow-x: scroll;
}

.album-group__container > .album-group {
  min-width: fit-content;
  border: 1px solid #ddd;
  padding: 8px;
  border-radius: 5px;
  font-weight: 500;
  cursor: pointer;
}

.album-group__container > .album-group:hover {
  opacity: 70%;
}

.album-group--active {
  color: #1890ff;
  font-weight: 700;
}

.icon-delete {
  color: #aaa9a9;
}

.icon-delete:hover {
  color: #c33f3f;
}
</style>
